"use client";
import * as React from "react";
const SvgSettingsSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.02 8.8H14q.05-.4.06-.8c.01-.4-.02-.53-.05-.8v.02L16 5.7l-1.97-3.4-2.32.93a6 6 0 0 0-1.38-.8h.01L9.97 0H6.03l-.36 2.46h.01q-.75.31-1.38.8v-.01L1.99 2.3 0 5.7l1.98 1.53v-.01A6 6 0 0 0 2 8.8v-.02L.3 10.1l-.27.21 1.96 3.36 2.33-.92-.01-.03q.64.5 1.4.8h-.03L6.04 16h3.92l.05-.34.3-2.12q.75-.31 1.4-.8l-.02.03 2.34.92 1.96-3.36-.26-.21zM8 10.8c-1.57 0-2.84-1.26-2.84-2.8S6.43 5.2 8 5.2s2.83 1.26 2.83 2.8S9.56 10.8 8 10.8" }));
export {
  SvgSettingsSharp as default
};
